module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.solutionlist.position1.length > 0) ? _c('div', {
    staticClass: "bottom_img",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "50vh"
    },
    attrs: {
      "src": _vm.solutionlist.position1[0].thumb
    }
  }), _vm._v(" "), (false) ? _c('p', {
    staticStyle: {
      "position": "absolute",
      "color": "#fff",
      "bottom": "10vh",
      "font-size": "6vh",
      "left": "12%",
      "border-bottom": "2px solid #ccc",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position1[0].title))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position2.length > 0) ? _c('div', {
    staticClass: "bbox"
  }, [_c('div', {
    staticClass: "row max_box"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', [_c('img', {
    staticClass: "bg-style",
    attrs: {
      "src": _vm.solutionlist.position2[0].thumb
    }
  })])]), _vm._v(" "), (_vm.solutionlist.position2.length > 1) ? _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "box_name"
  }, [_c('h3', {
    staticClass: "h1_title"
  }, [_vm._v(_vm._s(_vm.solutionlist.position2[1].title))]), _vm._v(" "), _c('div', {
    staticClass: "bor_bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_box_width"
  }, [_vm._v("\n            " + _vm._s(_vm.solutionlist.position2[1].brief) + "\n          ")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position3.length > 0) ? _c('div', {
    staticClass: "col-img-height",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.solutionlist.position3), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-2 p-r",
      on: {
        "mouseover": function($event) {
          return _vm.mouseOver(item)
        },
        "mouseleave": function($event) {
          return _vm.mouseLeave(item)
        }
      }
    }, [(index < 6) ? _c('div', [_c('img', {
      staticClass: "p-r-img",
      staticStyle: {
        "width": "100%",
        "height": "60vh",
        "border": "1px solid #fff"
      },
      attrs: {
        "src": item.thumb,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "p-a-lable"
    }, [_c('span', {
      staticStyle: {
        "background": "#f8b600",
        "padding-top": "5px",
        "padding-bottom": "5px"
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status1),
        expression: "item.status1"
      }],
      staticClass: "p-a"
    }, [_c('h2', {
      staticStyle: {
        "width": "100%",
        "text-align": "center",
        "color": "#fff",
        "margin-top": "30px",
        "font-size": "2vh"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px",
        "padding": "10px",
        "white-space": "pre-wrap"
      }
    }, [_vm._v(_vm._s(item.brief))])])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position4.length > 0) ? _c('div', {
    staticClass: "bbox-top"
  }, [_c('div', {
    staticClass: "row max_box"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.solutionlist.position4[0] != undefined) ? _c('div', {
    staticClass: "bbox-top_name"
  }, [_c('h3', {
    staticClass: "h1_title"
  }, [_vm._v(_vm._s(_vm.solutionlist.position4[0].title))]), _vm._v(" "), _c('div', {
    staticClass: "bor_bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_box_width"
  }, [_vm._v("\n            " + _vm._s(_vm.solutionlist.position4[0].brief) + "\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.solutionlist.position4[0] != undefined) ? _c('div', {
    staticClass: "bbox-top-bg-style"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "min-height": "36vh"
    },
    attrs: {
      "src": _vm.solutionlist.position4[0].thumb
    }
  })]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50840596"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Service.vue
// module id = 293
// module chunks = 1